import { MutationHookOptions, useMutation } from '@apollo/client'
import gql from 'graphql-tag'
import { itemFragments } from '@/domains/deals/hooks'
import { fragments } from '@/hooks/fragments'
import { Mutation, MutationUpdateItemArgs } from '@/schemaTypes'

const UPDATE_ITEM = gql`
  mutation updateItem($args: ItemUpdateArgs!) {
    updateItem(args: $args) {
      _id
      serialNumber
      imei
      itemSpecification
      note
      policeNumber
      isDamageCase
      isForPersonalUse
      usedGrade
      damageCasePeriods {
        from
        to
      }
      personalUsePeriods {
        from
        to
      }
      isInvestmentGold
      entrupyCertificateUrl
      checkedBy
      checkedAt
      storageFacilityId
      events {
        ...ItemEventFragment
      }
      vehicleData {
        vehicleProperties {
          make
          model
          regdate
          body
          facelift
          seats
          engine
          transmission
          odometer
          otherVehicleProperties {
            value
            name
          }
        }
        vin
        indicataId
        carPriceLastFetched
        vinLastFetched
        hasTypeCertificate
        hasApprovalCertificate
        has57aGutachten
        has57aGutachtenDue
        hasSecondKey
        hasSaleContract
      }
      checkedAfterAuction
    }
  }
  ${fragments.fileMetadata}
  ${itemFragments.itemEvent}
`

type TData = { updateItem: Mutation['updateItem'] }
type TVariables = MutationUpdateItemArgs

export function useUpdateItem(
  opts: MutationHookOptions<TData, TVariables> = {},
) {
  const [updateItem] = useMutation<TData, TVariables>(UPDATE_ITEM, opts)

  return updateItem
}
